import React from 'react';

import { CircleCkecked } from 'assets/icons';
import BlurPopup from 'components/BlurPopup';

import styles from './DeclineOfferThanksPopup.module.scss';

interface DeclineOfferThanksPopupProps {
  isModalOpen: boolean;
  onClose: () => void;
}

const DeclineOfferThanksPopup = ({ isModalOpen, onClose }: DeclineOfferThanksPopupProps) => {
  const handleClickClose = () => {
    onClose();
  };

  return (
    <BlurPopup
      id="popup"
      classes={{
        paper: styles.paper,
        container: styles.container,
      }}
      onClose={handleClickClose}
      open={isModalOpen}
      scroll="body"
      blurDeep={2}
      isCloseButtonDisplayed
    >
      <div className={styles.thanksPopup}>
        <CircleCkecked />
        <div className={styles.thanksPopupText}>
          Your loan inquiry through HFS Financial has been declined and canceled, per your request.
        </div>
      </div>
    </BlurPopup>
  );
};

export default DeclineOfferThanksPopup;
